angular.module('dpw.services')
    .value('getDisqusShortname', function () {
        !RCDPW.DISQUS_SHORTNAME && RCDPW.console.warn(
            'RCDPW.DISQUS_SHORTNAME is undefined.',
            'This is an issue when site is running on stage/production.'
        );
        return RCDPW.DISQUS_SHORTNAME || 'ringcentralblog-dev';
    })

    .factory('disqusHelpers', ['blogInfo', function (blogInfo) {
        return {
            getIdentifier: function (postId) {
                return postId + ' ' + blogInfo.host() + '/?p=' + postId;
            }
        };
    }])

    // Wrapper for `getPostDisqusIdentifier`
    // Used in Views.
    .filter('transformToDisqusIdentifier', ['disqusHelpers', function (disqusHelpers) {
        return function (id) {
            return disqusHelpers.getIdentifier(id);
        }
    }]);
